import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderCargoTaxiRecalculate from "./billings-order-cargo-taxi-recalculate";
import BillingsOrderCargoTaxiRecalculateParams from "./billings-order-cargo-taxi-recalculate-params";

const useBillingsOrderCargoTaxiRecalculate = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderCargoTaxiRecalculate | null>(null);

  const load = async (
    params: BillingsOrderCargoTaxiRecalculateParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.recalculateOrderCargoTaxiBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderCargoTaxiRecalculate;
